<template>
    <a-modal title="添加子账号"
             :width="600"
             :visible="visible"
             @cancel="$emit('cancel')"
             @ok="onSubmit"
             :maskClosable="false"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <a-form :form="form" class="form1">
            <a-form-item label="真实姓名">
                <a-input
                        placeholder = '请输入真实姓名'
                        v-decorator="['nickname', {rules: [{ required: true, message: '真实姓名不能为空' },{pattern:/^[\u4e00-\u9fa5]{1,}$/,message: '真实姓名必须是中文'}]}]"
                />
            </a-form-item>
            <a-form-item label="身份证号码">
                <a-input
                        placeholder = '请输入身份证号码'
                        v-decorator="['cardId',{rules: [{required: true,message: '身份证号不能为空'},{validator:fixedCardId}]}]"
                />
            </a-form-item>
            <a-form-item label="手机号" >
                <a-input
                        placeholder = '请输入手机号'
                        v-decorator="['phone',{rules: [{required: true,message: '手机号不能为空'},{validator: fixedAccount}]}]"
                />
            </a-form-item>
            <a-form-item label="密码">
                <a-input type="password"
                         placeholder = '6-20位字符,需含数字、大小写字母、下划线中的两种或以上'
                         v-decorator="['password', {rules: [{required: true, message: '密码不能为空' },{pattern:  /^(?![\d]+$)(?![a-zA-Z]+$)(?![_]+$)[\da-zA-Z_]{6,18}$/,message:'密码必须是6-20位数字、大小写字母、下划线中的两种或以上'}]}]"/>
            </a-form-item>
            <a-form-item label="确认密码">
                <a-input type="password"
                         placeholder = '请输入确认密码'
                         v-decorator="['password2', {rules: [{ required: true, message: '确认密码不能为空' }]}]"
                />
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'

    export default {
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                form: this.$form.createForm(this),
                modalLoading: false,
                params: {},
            }
        },
        methods: {
            ...mapActions(['Logout']),
            ...mapGetters(['nickname', 'avatar']),
            handleLogout() {
                const that = this
                this.$confirm({
                    title: '提示',
                    content: '真的要注销登录吗 ?',
                    onOk() {
                        return that.Logout({}).then(() => {
                        }).catch(err => {
                            that.$message.error({
                                title: '错误',
                                description: err.message
                            })
                        })
                    },
                    onCancel() {
                    }
                })
            },
            onSubmit() {
                let params = {...this.form.getFieldsValue()}
                if (params.password !== params.password2) {
                    this.$message.error('确认密码不正确!')
                    return
                }
                let that = this
                params.accountType = '2'
                this.form.validateFields((err, values) => {
                    if (err) {
                        return
                    }
                    params.account = params.phone
                    that.modalLoading = true
                    this.$http.post("/api/v1/supplier/account/add_child_account.json", qs.stringify(params, {allowDots: true})).then(function (res) {
                        that.modalLoading = false
                        if (res.code === 200) {
                            that.$message.success("添加成功!")
                            that.$emit('success')
                            that.$router.go(0)
                        }
                    })
                })
            },
            fixedAccount(rule, value, callback) {
                console.log(value)
                 // var reg = /[1][3,4,5,7,8][0-9]{9}/
                var reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
                if (!value){
                    callback('')
                }else if(!reg.test(value)) {
                    callback('手机号格式不正确')
                }else {
                    let params2 = {}
                    params2.account = value
                    this.$http.post('/api/v1/supplier/account/validateAccount.json',qs.stringify(params2, {allowDots: true})).then(function (res) {
                        if (res.result === false) {
                            callback('该手机号已注册');
                        }
                        callback();
                    });
                }
            },
            fixedCardId(rule, value, callback) {
                console.log(value)
                var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
                if(!value) {
                    callback('')
                }else if (!reg.test(value)) {
                    callback('身份证号不能为空')
                }else {
                    let params2 = {}
                    params2.cardId = value
                    this.$http.post('/api/v1/supplier/account/validateAccount.json',qs.stringify(params2, {allowDots: true})).then(function (res) {
                        if (res.result === false) {
                            callback('该身份证号已存在!');
                        }
                        callback();
                    });
                }
            }
        }
    };
</script>
<style lang="less" scoped>
    /deep/ .form1 .ant-form-item{
        display: flex;
    }
    /deep/ .form1 .ant-form-item-label{
        flex-grow: 0;
        flex-shrink: 0;
        width: 100px;
    }
    /deep/ .form1 .ant-form-item-control-wrapper{
        flex: 1 1 100%;
        padding-left: 20px;
    }
</style>
